module.exports = __webpack_public_path__ + "static/media/dopuszczenie-HC-off.f231ee10.svg";